import { CALL_METHODS } from '../../../../types';

export const METHOD_DESCRIPTIONS = {
  [CALL_METHODS.NAVIGATE]: 'Navigate to different pages while keeping the chat open',
  [CALL_METHODS.SET_FORM_FIELDS]: 'Update Redux form fields with optional streaming animation',
  [CALL_METHODS.SET_CONTEXT]: 'Update context values directly',
  [CALL_METHODS.SEARCH_NONPROFITS]: 'Search for nonprofits based on criteria',
  [CALL_METHODS.GENERATE]: 'Execute AI generation with preset or generative batches',
  [CALL_METHODS.BATCH_GENERATE]: 'Execute multiple AI generations in batches',
  [CALL_METHODS.LOAD_NONPROFITS]: 'Load nonprofit data from an array of organization IDs',
  [CALL_METHODS.LOAD_CAUSES]: 'Load and categorize all causes into SDGs and categories',
  [CALL_METHODS.LOAD_PICTURES]: 'Load all pictures with resources and categories',
  [CALL_METHODS.LOAD_USER]: 'Load current user data including organization details',
  [CALL_METHODS.SET_DEFAULT_PICTURE]: 'Set a random matching picture based on category selection',
  [CALL_METHODS.WAIT_FOR_CONTEXT]:
    'Wait for specific context values to be populated before continuing',
  [CALL_METHODS.DEBUG]: 'Dump the entire context to browser console for debugging',
  [CALL_METHODS.DELAY]: 'Simple delay method for timing control',
  [CALL_METHODS.PARSE_DATA]: 'Parse and transform data from one format to another',
  [CALL_METHODS.REDUX]: 'Advanced: Directly read/write Redux state (bypasses normal boundaries)',
};

export const FORM_FIELD_EXAMPLES = [
  'app/CampaignPageForm',
  'app/FundraiserPageForm',
  'app/EventPageForm',
  'app/VolunteerPageForm',
  'app/DeedFormPage',
];

export const GENERATION_ID_EXAMPLES = [
  'campaign-content-generator',
  'fundraiser-description-generator',
  'event-details-generator',
];
